import { type PopularSdkKey, type SdkKey, getSdkInfoByKey, POPULAR_SDK_KEYS } from '@gonfalon/sdk-info/sdkInfo';
import type { SdkInitKeys, SnippetLang } from '@gonfalon/sdk-info/types';

export const getDisplayName = (sdk: SdkKey) => getSdkInfoByKey(sdk).name;

export const getIcon = (sdk: SdkKey) => {
  const Icon = getSdkInfoByKey(sdk).icon;
  return <Icon size="small" />;
};

export const isPopularSdk = (sdk: SdkKey): sdk is PopularSdkKey => {
  return POPULAR_SDK_KEYS.includes(sdk as PopularSdkKey);
};

export const getPrismLang = (sdk: SdkKey): SnippetLang => {
  return getSdkInfoByKey(sdk).prismLang;
};

export const getSdkInitSnippet = (sdk: SdkKey, sdkInitKeys: SdkInitKeys, memberId: string) => {
  const SDK_KEY_PLACEHOLDER = 'YOUR_SDK_KEY';
  const MOBILE_KEY_PLACEHOLDER = 'YOUR_MOBILE_KEY';
  const CLIENT_SIDE_ID_PLACEHOLDER = 'YOUR_CLIENT_SIDE_ID';
  const YOUR_MEMBER_ID_PLACEHOLDER = 'YOUR_MEMBER_ID';

  const metadata = getSdkInfoByKey(sdk);
  return metadata.initSnippet
    ?.replaceAll(SDK_KEY_PLACEHOLDER, sdkInitKeys.serverSide)
    .replaceAll(MOBILE_KEY_PLACEHOLDER, sdkInitKeys.mobile)
    .replaceAll(CLIENT_SIDE_ID_PLACEHOLDER, sdkInitKeys.clientSide)
    .replaceAll(YOUR_MEMBER_ID_PLACEHOLDER, memberId);
};

export const getSdkKeyFromEnvironment = (sdkKebabName: SdkKey, sdkInitKeys: SdkInitKeys) => {
  const { initKey } = getSdkInfoByKey(sdkKebabName);

  return sdkInitKeys[initKey[0]];
};

/**
 * Human-readable label for the credential an SDK uses (e.g. "SDK key", "Mobile key",
 * "Client-side ID"). Use in user-facing copy that references the credential by name —
 * the generic "SDK key" is misleading for client-side and mobile users.
 */
export const getSdkKeyTypeLabel = (sdkKebabName: SdkKey): string => {
  const { initKey } = getSdkInfoByKey(sdkKebabName);
  switch (initKey[0]) {
    case 'serverSide':
      return 'SDK key';
    case 'mobile':
      return 'Mobile key';
    case 'clientSide':
      return 'Client-side ID';
    default:
      return 'key';
  }
};
